import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME } from '@modules/players-bonuses/constants';
import {
  ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME,
  TRANSLATION_PLAYER_BONUS_CREATE,
} from '@modules/players-bonuses/submodules/create/constants';
import {
  FileBonusCreateModule,
} from '@modules/players-bonuses/submodules/create/submodules/file-bonus-create/FileBonusCreateModule';
import {
  PLAYERS_BONUS_CREATE_MANUALLY_ROUTE_NAME,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/constants';
import {
  ManuallyBonusCreateModule,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/ManuallyBonusCreateModule';
import { getTranslationKeys } from '@modules/players-bonuses/submodules/create/translations';

export class PlayersBonusesCreateModule extends AppModule {
  protected submodules = [
    new ManuallyBonusCreateModule(),
    new FileBonusCreateModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYERS_BONUSES_ADDITIONAL_ROUTE_NAME, {
      name: ADMIN_PLAYERS_BONUSES_CREATE_ROUTE_NAME,
      path: 'add',
      component: () => import('@modules/players-bonuses/submodules/create/pages/PlayersBonusesCreatePage/PlayersBonusesCreatePage.vue'),
      redirect: { name: PLAYERS_BONUS_CREATE_MANUALLY_ROUTE_NAME },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_PLAYER_BONUS_CREATE, getTranslationKeys);
  }
}
